import api from "./api";

export function getHomeDetail() {
  return api.get(`/home`);
}

export function createHomeDetails(data) {
  return api.post("/home", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function updateHomeDetails(id, data) {
  return api.put(`/home/${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}